import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import {
  RecomendationApiRequest,
  DeleteRecomendationRequest,
} from '@/data/payload/api/RecomendationRequest'
import { RecomendationPresenter } from '@/app/ui/presenters/RecomendationPresenter'
import { Recomendation } from '@/domain/entities/Recommendation'
import router from '@/router'
import Vue from 'vue'
import { GuideCategoryPresenter } from '@/app/ui/presenters/GuideCategoryPresenter'
import { GuideCategory } from '@/domain/entities/GuideCategory'
import { TrainingCategoryPresenter } from '@/app/ui/presenters/TrainingCategoryPresenter'
import { TrainingCategory } from '@/domain/entities/TrainingCategory'
import { AdditionalInfo } from '@/domain/entities/AdditionalInfo'
import { AdditionalInfoPresenter } from '@/app/ui/presenters/AdditionalInfoPresenter'
import { Bulletin } from '@/domain/entities/Bulletin'
import { AuthModule } from './auth'

export interface RecomendationState {
  recomendationData: Recomendation
  guideCategoryData: GuideCategory
  trainingCategoryData: TrainingCategory
  additionalData: AdditionalInfo
  bulletinData: Bulletin
  isLoading: boolean
  fields: any
}

@Module({ namespaced: true, dynamic: true, store, name: 'recomendation' })
class Recomendations extends VuexModule implements RecomendationState {
  public recomendationData = new Recomendation(true, '')
  public guideCategoryData = new GuideCategory(true, '')
  public trainingCategoryData = new TrainingCategory(true, '')
  public additionalData = new AdditionalInfo(true, '')
  public bulletinData = new Bulletin(true, '')
  public isLoading = true
  public fields = [
    { key: 'no', sortable: false },
    { key: 'type', sortable: true },
    { key: 'title', sortable: true },
    { key: 'recomended', sortable: false },
  ]

  public paginationParamQuickGuide = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
    },
    category: 'sop',
  }

  public paginationParamTraining = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
    },
    category: 'training',
  }
  public paginationParamAdditionalinfo = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
    },
    search: '',
  }
  public paginationParamBuletin = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
    },
    search: '',
  }

  @Action
  public async getRecomendationData() {
    this.setLoading(true)
    const presenterRecomendation = await container.resolve(
      RecomendationPresenter
    )
    presenterRecomendation
      .loadRecomendation(new Map())
      .then(async (res: Recomendation) => {
        this.setRecomendationData(res)
        //  console.log('data', res)
      })
      .then(async () => {
        await presenterRecomendation
          .loadTrainingCategories(this.paginationParamTraining)
          .then((res: TrainingCategory) => {
            this.setTrainingCategoryData(res)
            //  console.log('data', res)
          })
      })
      .then(async () => {
        await presenterRecomendation
          .loadAdditionalInfo(this.paginationParamAdditionalinfo)
          .then((res: AdditionalInfo) => {
            this.setAdditionalInfo(res)
            //  console.log('data', res)
          })
      })
      .then(async () => {
        await presenterRecomendation
          .loadBulletin(this.paginationParamBuletin)
          .then((res: Bulletin) => {
            this.setBulletinData(res)
            //  console.log('data', res)
          })
      })
      .then(async () => {
        await presenterRecomendation
          .loadGuideCategories(this.paginationParamQuickGuide)
          .then((res: GuideCategory) => {
            this.setGuideCategoryData(res)
            //  console.log('data', res)
            this.setLoading(false)
          })
      })
      .catch((error) => {
        router.push('/404/index')
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
        this.setLoading(false)
      })
    // Promise.resolve().then(async () => {
    //   const presenterRecomendation = await container.resolve(RecomendationPresenter)
    //     presenterRecomendation
    //       .loadRecomendation(new Map())
    //       .then(async (res: Recomendation) => {
    //         this.setLoading(false)
    //         this.setRecomendationData(res)
    //         console.log('data', res)
    //       })
    // }).
    //   then(
    //     async () => {
    //       const presenterTraining = await container.resolve(RecomendationPresenter)
    //       presenterTraining
    //         .loadTrainingCategories(this.paginationParamTraining)
    //         .then((res: TrainingCategory) => {
    //           this.setTrainingCategoryData(res)
    //           console.log('data', res)
    //         })
    //     }
    //   ).then(async () => {
    //     const presenterAdditionalInfo = await container.resolve(RecomendationPresenter)
    //     presenterAdditionalInfo
    //       .loadAdditionalInfo(this.paginationParamAdditionalinfo)
    //       .then((res: AdditionalInfo) => {
    //         this.setAdditionalInfo(res)
    //         console.log('data', res)
    //       })
    //   }).then(async () => {
    //     const presenterBuletin = await container.resolve(RecomendationPresenter)
    //     presenterBuletin
    //       .loadBulletin(this.paginationParamBuletin)
    //       .then((res: Bulletin) => {
    //         console.log('bulletin =====>', res)
    //         this.setBulletinData(res)
    //       })
    //   }).then(async () => {
    //     const presenterQuickGuide = await container.resolve(RecomendationPresenter)
    //     presenterQuickGuide
    //     .loadGuideCategories(this.paginationParamQuickGuide)
    //     .then((res: GuideCategory) => {
    //       this.setGuideCategoryData(res)
    //       console.log('data', res)
    //     })

    //   }).catch((error) => {
    //     router.push('/404/index')
    //     console.error('error', error)
    //   })
  }

  // @Action
  // public async getRecomendation() {
  //   this.setLoading(true)
  //   const presenter = await container.resolve(RecomendationPresenter)
  //   presenter
  //     .loadRecomendation(new Map())
  //     .then(async (res: Recomendation) => {
  //       this.setLoading(false)
  //       this.setRecomendationData(res)
  //       console.log('data', res)
  //     })
  //     .catch((error) => {
  //       this.setLoading(false)
  //       router.push('/404/index')
  //       console.error('error', error)
  //     }).then
  // }

  @Action
  public async postRecomendation(params: {
    contentId: number
    contentType: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(RecomendationPresenter)
    presenter
      .postRecomendation(
        new RecomendationApiRequest(params.contentId, params.contentType)
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Recomendation',
          message: res.message,
          type: 'success',
          duration: 5000,
        })
        this.getRecomendationData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async deleteRecomendation(params: {
    contentType: string
    contentId: number
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(RecomendationPresenter)
    presenter
      .deleteRecomendation(
        new DeleteRecomendationRequest(params.contentType, params.contentId)
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Recomendation',
          message: res.message,
          type: 'success',
          duration: 5000,
        })
        this.getRecomendationData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Mutation
  private setGuideCategoryData(guideCategory: GuideCategory) {
    this.guideCategoryData = guideCategory
  }

  @Mutation
  private setRecomendationData(recomendation: Recomendation) {
    this.recomendationData = recomendation
  }

  @Mutation
  private setAdditionalInfo(additional: AdditionalInfo) {
    this.additionalData = additional
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }

  @Mutation
  private setTrainingCategoryData(trainingCategory: TrainingCategory) {
    this.trainingCategoryData = trainingCategory
  }

  @Mutation
  private setBulletinData(bulletin: Bulletin) {
    this.bulletinData = bulletin
  }
}

export const RecomendationModule = getModule(Recomendations)
